import { createAction } from '@reduxjs/toolkit'

import { curryActionForPage } from 'helpers/curry'
import { ActionForPagePayload, Dashboard, Pagination, Sorter } from 'types'

// Dashboard
export const fetchDashboardSuccess = createAction<
    ActionForPagePayload<Dashboard | null>
>('FETCH_DASHBOARD_SUCCESS')
export const makeFetchDashboardSuccess = curryActionForPage(
    fetchDashboardSuccess
)

// Update Widget Sorter
export const updateWidgetSorter = createAction<
    ActionForPagePayload<{ widgetId: string; sorter: Sorter }>
>('UPDATE_WIDGET_SORTER')
export const makeUpdateWidgetSorter = curryActionForPage(updateWidgetSorter)

// Update Widget Pagination
export const updateWidgetPagination = createAction<
    ActionForPagePayload<{ widgetId: string; pagination: Pagination }>
>('UPDATE_WIDGET_PAGINATION')
export const makeUpdateWidgetPagination = curryActionForPage(
    updateWidgetPagination
)

// Update Widget Table Settings
export const updateWidgetTableColumns = createAction<
    ActionForPagePayload<{
        widgetId: string
        metrics: unknown
        group_by: unknown
    }>
>('UPDATE_WIDGET_TABLE_COLUMNS')
export const makeUpdateWidgetTableColumns = curryActionForPage(
    updateWidgetTableColumns
)
